var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56719 7.3031L7.60312 10.4906H10.9547L8.24531 12.464L9.28125 15.6515L6.56719 13.6828L3.85313 15.6515L4.89375 12.464L2.17969 10.4906H5.53125L6.56719 7.3031Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2266 18.5859L13.4344 17.6109L12.2625 18.0656L12.9422 17.0109L12.15 16.0312L13.3641 16.3547L14.0484 15.3L14.1141 16.5562L15.3328 16.8797L14.1563 17.3297L14.2266 18.5859Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8016 15.7266L16.1766 14.5266L15.15 13.8L16.4063 13.7812L16.7766 12.5812L17.1844 13.7719L18.4406 13.7578L17.4328 14.5078L17.8359 15.6984L16.8094 14.9719L15.8016 15.7266Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.925 8.80781L17.3719 9.93749L18.2719 10.8141L17.0297 10.6359L16.4766 11.7609L16.2609 10.5234L15.0141 10.3453L16.1297 9.75937L15.9141 8.51718L16.8141 9.39374L17.925 8.80781Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2594 5.38593L14.1656 6.63749L15.3328 7.11093L14.1094 7.41093L14.0203 8.66718L13.3594 7.59843L12.1359 7.89843L12.9469 6.93749L12.2813 5.87343L13.4484 6.34686L14.2594 5.38593Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.594d70d9f0345eb153599abc8af58d49.svg";
export { ForwardRef as ReactComponent };